export class OrderAssetParameters {
  w?: number;

  h?: number;

  dpi?: number;

  fm?: string;

  cs?: string;
}
